import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const DuplicateFormMetadataForm = () => {
  const [previousFormId, setPreviousFormId] = useState("");
  const [formName, setFormName] = useState("");
  const [formLabel, setFormLabel] = useState("");
  const [formCode, setFormCode] = useState("");
  const [domainClassType, setDomainClassType] = useState("");
  const [domainCode, setDomainCode] = useState("");
  const [domainLabel, setDomainLabel] = useState("");
  const [formType, setFormType] = useState("");
  const [formRepeat, setFormRepeat] = useState("");
  const [formCategory, setFormCategory] = useState("");
  const [customForm, setCustomForm] = useState("");
  const [unscheduledForm, setUnscheduledForm] = useState("no");
  const [unbliendForm, setUnbliendForm] = useState("");
  const [initiateOrder, setInitiateOrder] = useState("");
  const [formMetadataList, setFormMetadataList] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [duplicatButtonLoader, setDuplicateButtonLoader] = useState(false)
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setFormMetadataList(data?.data || []);
  };

  const duplicateStudyLevelForm = async () => {
    setDuplicateButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.previousFormId = previousFormId
    userData.formName = formName
    userData.formLabel = formLabel
    userData.formCode = formCode
    userData.domainClassType = domainClassType
    userData.domainCode = domainCode
    userData.domainLabel = domainLabel
    userData.formType = formType
    userData.formRepeat = formRepeat
    userData.formCategory = formCategory
    userData.customForm = customForm
    userData.unbliendForm = unbliendForm
    userData.unscheduledForm = unscheduledForm
    userData.initiateOrder = initiateOrder
    userData.category = LoginCat
    let data = await studyLevelFormManagementServices.duplicateStudyLevelForm(userData)
    if (data?.statusCode === 200) {
      clearForm()
    }
    setDuplicateButtonLoader(false)
  }

  const selectedPreviousForm = (previousFormId) => {
    let selectedData = formMetadataList?.find(item => item.formId === previousFormId)
    setFormName(selectedData?.formName)
    setFormLabel(selectedData?.formLabel)
    setFormCode(selectedData?.formCode)
    setDomainClassType(selectedData?.domainClassType)
    setDomainCode(selectedData?.domainCode)
    setDomainLabel(selectedData?.domainLabel)
    setFormType(selectedData?.formType)
    setFormRepeat(selectedData?.formRepeat)
    setFormCategory(selectedData?.formCategory)
    setCustomForm(selectedData?.customForm)
    setUnbliendForm(selectedData?.unbliendForm)
    setUnscheduledForm(selectedData?.unscheduledForm)
    setInitiateOrder(selectedData?.initiateOrder)
  }

  const clearForm = () => {
    setPreviousFormId("")
    setFormName("")
    setFormLabel("")
    setFormCode("")
    setDomainClassType("")
    setDomainCode("")
    setDomainLabel("")
    setFormType("")
    setFormRepeat("")
    setFormCategory("")
    setCustomForm("")
    setUnbliendForm("")
    setUnscheduledForm("")
    setInitiateOrder("")
  }

  useEffect(() => {
    clearForm();
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    if (previousFormId) {
      selectedPreviousForm(previousFormId);
    }
  }, [previousFormId]);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form List{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setPreviousFormId(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={previousFormId === ""} value="">Select Form</option>
          {formMetadataList?.map((item, index) => (
            <option key={index} selected={previousFormId === item?.formId} value={item?.formId}>{item?.formLabel}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Form Name{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setFormName(e.target.value)}
          value={formName}
          className="br3"
          placeholder="Form Name"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Form Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setFormLabel(e.target.value)}
          value={formLabel}
          className="br3"
          placeholder="Form Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Form Code{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setFormCode(e.target.value)}
          value={formCode}
          className="br3"
          placeholder="Form Code"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Domain Class Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setDomainClassType(e.target.value)}
          value={domainClassType}
          className="br3"
          placeholder="Domain Class Type"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Domain Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setDomainLabel(e.target.value)}
          value={domainLabel}
          className="br3"
          placeholder="Domain Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Domain Code{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => {
            const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
            setDomainCode(input);
          }}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
          }}
          value={domainCode}
          className="br3"
          placeholder="Domain Code"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Form Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setFormType(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={formType === ""} value="">Select Form Type</option>
          <option selected={formType === "regular"} value="regular">Regular</option>
          <option selected={formType === "log"} value="log">Log</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Form Repeat{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setFormRepeat(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={formRepeat === ""} value="">Select Form Repeat</option>
          <option selected={formRepeat === "yes"} value="yes">Yes</option>
          <option selected={formRepeat === "no"} value="no">No</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Category{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => {
            setFormCategory(e.target.value);
            setUnscheduledForm('no')
          }}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={formCategory === ""} value="">Select Form Category</option>
          <option selected={formCategory === "initiateForm"} value="initiateForm">Initiate Form</option>
          <option selected={formCategory === "eventForm"} value="eventForm">Event Form</option>
          <option selected={formCategory === "specialForm"} value="specialForm" id="">Special Form</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Unscheduled Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setUnscheduledForm(e.target.value)}
          className="br3"
          disabled={formCategory !== "eventForm"}
          style={{ fontSize: 12 }}
        >
          <option selected={unscheduledForm === ""} value="">Select Unscheduled Form</option>
          <option selected={unscheduledForm === "no"} value="no">No</option>
          <option selected={unscheduledForm === "yes"} value="yes">Yes</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Custom Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setCustomForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={customForm === ""} value="">Select Custom Form</option>
          <option selected={customForm === "no"} value="no">No</option>
          <option selected={customForm === "tenderSwallen"} value="tenderSwallen">Tender/Swallen</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Unbliend Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setUnbliendForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={unbliendForm === ""} value="">Select Unbliend Form</option>
          <option selected={unbliendForm === "no"} value="no">No</option>
          <option selected={unbliendForm === "yes"} value="yes">Yes</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Initiate Order{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setInitiateOrder(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={initiateOrder === ""} value="">Select Initiate Order</option>
          <option selected={initiateOrder === "formOrder"} value="formOrder">Form Order</option>
          <option selected={initiateOrder === "anyTime"} value="anyTime">Any Time</option>
        </Form.Select>
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!previousFormId || duplicatButtonLoader || !formName || !formLabel || !formCode || !domainClassType || !domainCode || !domainLabel || !formType || !formRepeat || !formCategory || !customForm || !unbliendForm|| !unscheduledForm || !initiateOrder}
          onClick={duplicateStudyLevelForm}
          className="updateProfile"
        >
          {duplicatButtonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Duplicating...
            </div>
          ) : (
            "Duplicate Metadata"
          )}
        </button>
      </div>
    </div>
  );
};

export default DuplicateFormMetadataForm;
